module.exports = __webpack_public_path__ + "static/media/citybrake.9dc947d2.mp4";